// Functions used to extract strings

const dummyFunction = (el) => el
const pDummyFunction = (ctx, el) => el

export const $gettextInterpolate = dummyFunction // Vue.prototype.$gettextInterpolate
export const $gettext = dummyFunction // Vue.prototype.$gettext
export const $pgettext = pDummyFunction // Vue.prototype.$pgettext
